<div class="bg-white"></div>
<div class="logo-container">
    <a (click)="goToConfig()">
        <img class="logo" src="../../assets/bed-bath-logo@2x.png" alt="logo">
    </a>
    <div class="buenfin-logo-container">
        <a (click)="goToGanadores()">
            <img class="buenfin-logo" src="../../assets/buenfin-logo.png" alt="logo">
        </a>
    </div>
</div>
<a (click)="goToGame()">
    <div class="text-1-container">
        <img class="press-icon" src="../../assets/press.png" alt="logo">
        <span class="text-1">
            Toca aquí<br>para jugar
        </span>
    </div>
</a>
<a (click)="goToPremios()">
    <div class="text-2-container">
        <span class="text-2">
            Ver premios
        </span>
        <img class="arrow-right" src="../../assets/arrow-right.png" alt="logo">
    </div>
</a>

<span style="position: absolute;bottom: 0;color: #ccc;">
    1.0.4
</span>

<div class="pre-load">
    <img class="bbb-logo" src="../../assets/bed-bath-logo.png" alt="bbb-logo">
    <img class="bf-logo" src="../../assets/buen-fin-logo@3x.png" alt="bf-logo">
    <img class="bf-logo" src="../../assets/slot-machine.png" alt="bf-logo">
    <img class="bf-logo" src="../../assets/slot-resultados.png" alt="bf-logo">
  </div>
